import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';

export type LineItemState = {
  readonly isDeletingLineItem: boolean;
  readonly isDeletingCustomsItem: boolean;
};

const lineItemInitialState: LineItemState = {
  isDeletingLineItem: false,
  isDeletingCustomsItem: false,
};

function lineItemReducer(
  state: LineItemState = lineItemInitialState,
  action: ActionTypes,
): LineItemState {
  switch (action.type) {
    case ActionKeys.LINE_ITEMS_DELETE:
      return {
        ...state,
        isDeletingLineItem: true,
      };
    case ActionKeys.LINE_ITEMS_DELETE_ERROR:
    case ActionKeys.LINE_ITEMS_DELETE_SUCCESS:
      return {
        ...state,
        isDeletingLineItem: false,
      };

    case ActionKeys.CUSTOMS_ITEM_DELETE:
      return {
        ...state,
        isDeletingCustomsItem: true,
      };
    case ActionKeys.CUSTOMS_ITEM_DELETE_ERROR:
    case ActionKeys.CUSTOMS_ITEM_DELETE_SUCCESS:
      return {
        ...state,
        isDeletingCustomsItem: false,
      };
    default:
      return state;
  }
}

export default lineItemReducer;
